import { render } from "./LoginCpfView.vue?vue&type=template&id=0d88bc07&scoped=true"
import script from "./LoginCpfView.vue?vue&type=script&lang=js"
export * from "./LoginCpfView.vue?vue&type=script&lang=js"

import "./LoginCpfView.vue?vue&type=style&index=0&id=0d88bc07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d88bc07"]])

export default __exports__